import React from 'react';
import { observer } from 'mobx-react';
import { Position } from '@xyflow/react';
import { 
  NodeContainer, 
  EntityIcon, 
  EntityContent, 
  EntityName, 
  EntityMeta,
  StyledHandle,
  OuterSelectionBorder,
  InnerSelectionBorder
} from './CustomEntityNode.styles';
import { HoldingEntitySvg } from '../EntityIcons';

const CustomEntityNode = observer((props) => {
  const { data, selected } = props;
  const {
    name = 'Unnamed Entity',
    color = '#DACEE0',
    itemCount = 0
  } = data;

  return (
    <NodeContainer isSelected={selected}>
      <StyledHandle
        type="target"
        position={Position.Top}
        id="top"
      />
      <StyledHandle
        type="source"
        position={Position.Bottom}
        id="bottom"
      />
      
      <EntityIcon color={color}>
        <HoldingEntitySvg width={24} height={24} color="#1A1B1D" />
      </EntityIcon>
      
      <EntityContent>
        <EntityName title={name}>
          {name}
        </EntityName>
        {itemCount ? <EntityMeta>{itemCount} item{itemCount > 1 && 's'}</EntityMeta> : null}
      </EntityContent>
      
      {selected && (
        <>
          <OuterSelectionBorder />
          <InnerSelectionBorder />
        </>
      )}
    </NodeContainer>
  );
});

export default CustomEntityNode; 